<template>
  <div class="campaigns-menu">
    <vs-tabs
      position="left"
      class="tabs-shadow-none mt-2"
      id="profile-tabs"
      :key="isSmallerScreen"
    >
      <vs-tab
        icon-pack="feather"
        icon="icon-settings"
        :label="!isSmallerScreen ? 'HQ created' : ''"
      >
        <div class="lists-view-tab">
          <master-campaign-list />
        </div>
      </vs-tab>
      <vs-tab
        icon-pack="feather"
        icon="icon-check-circle"
        :label="!isSmallerScreen ? 'Pending approval' : ''"
      >
        <div class="lists-view-tab">
          <venue-campaign-for-approval-list
            title="Venue campaigns pending approval"
            description="Venue campaigns that have been created by a venue and are awaiting approval by HQ."
          />
        </div>
      </vs-tab>
      <vs-tab
        icon-pack="feather"
        icon="icon-list"
        :label="!isSmallerScreen ? 'All campaigns' : ''"
      >
        <div class="lists-view-tab">
          <all-venue-campaigns-list
            title="All venue campaigns"
            description="Browse all venue campaigns across countries and statuses."
          />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import VenueCampaignForApprovalList from "./VenueCampaignsForApprovalList.vue";
import AllVenueCampaignsList from "./AllVenueCampaignsList.vue";
import MasterCampaignList from "./MasterCampaignList.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    VenueCampaignForApprovalList,
    AllVenueCampaignsList,
    MasterCampaignList,
  },
  data() {
    return {};
  },
  async mounted() {},
  methods: {},
  computed: {
    ...mapGetters({
      activeVenue: "users/userId",
    }),
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
  },
};
</script>

<style lang="scss">
.campaigns-menu {
  .con-slot-tabs {
    overflow: hidden !important;
  }
  .lists-view-tab {
    margin-left: 12px;
  }
}
</style>
